




















import { defineComponent } from '@vue/composition-api'
import { MD5 } from 'crypto-js'

interface ImageDetailsInterface {
  xRatio: number,
  yRatio: number,
  newArea: {
    metadata: {
      x1: number,
      y1: number,
      x2: number,
      y2: number,
    },
  },
  imageDisplayWidth: number,
  imageDisplayHeight: number,
}

export default defineComponent({
  name: 'ImageWithBoundaryBox',
  props: {
    imageLink: {
      type: String,
      required: true,
    },
    imageElements: {
      type: Object,
      required: true,
    },
    onClickMethod: {
      type: Function,
    },
    keyFromParent: {
      type: String,
      default: '',
    },
  },
  data(): ImageDetailsInterface {
    return {
      xRatio: 1,
      yRatio: 1,
      newArea: {
        metadata: {
          x1: 100,
          y1: 100,
          x2: 200,
          y2: 200,
        },
      },
      imageDisplayWidth: 200,
      imageDisplayHeight: 200,
    }
  },
  mounted() {
    window.addEventListener('resize', this.onImageLoad)
  },
  methods: {
    goToImageDetails(imageLink: string) {
      console.log(imageLink)
      console.log(MD5(imageLink))
      this.$router.push({
        name: 'catalogInstanceImageDetailsFromProduct',
        params: { imageId: MD5(imageLink).toString(), catalogId: this.$route.params.catalogId, productId: this.$route.params.productId },
      })
    },
    onImageLoad() {
      const image = this.$refs.image as HTMLImageElement | null
      if (image != null) {
        this.xRatio = image.width / image.naturalWidth
        this.yRatio = image.height / image.naturalHeight
        this.imageDisplayWidth = image.width
        this.imageDisplayHeight = image.height
      }
    },
    getRectangleStyle(imageBoundaryBox: { x1: number, y1: number, x2: number, y2: number }, index: number) {
      const colors = ['#e9306c', '#fbdc2d', '#44bb9b']

      return {
        left: `${imageBoundaryBox.x1 * this.xRatio}px`,
        top: `${imageBoundaryBox.y1 * this.yRatio}px`,
        width: `${(imageBoundaryBox.x2 - imageBoundaryBox.x1) * this.xRatio}px`,
        height: `${(imageBoundaryBox.y2 - imageBoundaryBox.y1) * this.yRatio}px`,
        border: `2px solid ${colors[index % 3]}`,
        position: 'absolute',
        'font-weight': 'bold',
        'font-size': 'large',
        color: 'black',
        'text-shadow': '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff',
      }
    },
  },
})
